import { useMemo } from 'react';
import styled from 'styled-components';

import { PurchaseAddressDto } from 'services/order/orderService.dto';

import { NewShippingAddress } from './components/NewShippingAddress';
import { ShippingAddressesList } from './components/ShippingAddressesList';
import { ShippingAddressSuggestions } from './components/suggestions/ShippingAddressSuggestions';
import { ShippingAddressUiProvider, useShippingAddressUi } from './ShippingAddressUiProvider';
import { areAddressesEqual } from './utils/shippingAddressUtils';

const Container = styled.div`
  height: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

interface Props {
  header?: string;
  onAddressSelected?: (addressId: number) => void;
  orderAddress?: PurchaseAddressDto;
  addressId?: number;
}

const OrderAddressesModuleContent = ({ header, onAddressSelected, orderAddress, addressId }: Props) => {
  const { displayMode, shippingAddresses } = useShippingAddressUi();

  const activeAddressId = useMemo(() => {
    if (orderAddress) return shippingAddresses.find(address => areAddressesEqual(address, orderAddress))?.id;
    return addressId;
  }, [shippingAddresses, orderAddress, addressId]);

  return (
    <Container>
      {displayMode === 'LIST' && (
        <ShippingAddressesList
          header={header}
          onAddressSelected={onAddressSelected}
          activeAddressId={activeAddressId}
        />
      )}
      {displayMode === 'NEW' && <NewShippingAddress header={header} />}
      {displayMode === 'SUGGESTION' && <ShippingAddressSuggestions header={header} />}
    </Container>
  );
};

export const OrderAddressesModule = (props: Props) => (
  <ShippingAddressUiProvider>
    <OrderAddressesModuleContent {...props} />
  </ShippingAddressUiProvider>
);
